import React from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { Chip, makeStyles, Typography } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  chip: {
    border: `1px solid ${theme.colors['primary-200']}`,
    '&.MuiChip-clickable:hover': {
      border: `1px solid ${theme.colors['primary-350']}`,
    },
  },
}))

const ButtonFilter = (props) => {
  const classes = useStyles()

  const {
    id = 'button-filter',
    label,
    className,
    onClick = () => {},
    isActive = false,
    disabled = false,
    ...rest
  } = props

  return (
    <Chip
      {...rest}
      id={id}
      className={clsx(
        className,
        classes.chip,
        'px-10 normal-case rounded-full',
      )}
      disabled={disabled}
      onClick={() => onClick()}
      label={
        <Typography
          className={clsx(
            isActive ? 'font-bold' : 'font-normal',
            'flex items-center',
          )}
        >
          {label}
        </Typography>
      }
    />
  )
}

ButtonFilter.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  onClick: PropTypes.func,
  isActive: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
}

export default ButtonFilter
